import { Message } from "element-ui";
import router from "@/router";

let redirectingToLogin = false;

export function clearLoginState({ clearRememberedPassword = false } = {}) {
  localStorage.removeItem("twoToken");
  localStorage.removeItem("tk");
  localStorage.removeItem("loginPhone");
  localStorage.removeItem("nickName");

  if (clearRememberedPassword) {
    localStorage.removeItem("tt");
  }
}

export function forceRelogin(
  message = "登录状态已失效，请重新输入密码登录"
) {
  clearLoginState({ clearRememberedPassword: true });

  if (redirectingToLogin) {
    return;
  }

  redirectingToLogin = true;
  Message.warning(message);

  if (router.currentRoute.path !== "/login") {
    router
      .replace({ path: "/login", query: { reason: "session-invalid" } })
      .catch(() => {});
  }

  setTimeout(() => {
    redirectingToLogin = false;
  }, 1500);
}
